module.exports = __webpack_public_path__ + "d5ae11d7bd71d09b9f287616d8b3fffa.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/sponsors.png
// module id = 981
// module chunks = 2